<div class="flex gap-2 border-b-2 border-sidebar bg-page-header p-4 sm:px-5 sm:py-2.5 lg:gap-4">
    <div class="button-group" #propertiesAnchor
         [class.hidden]="!buttonStates.showDropdownButton || userType == UserType.AnonymousUser || userType == UserType.ExternalUser || !pwaService.isOnline">
        <kendo-menu (select)="onPropertiesMenuItemClicked($event)" [openOnClick]="{toggle: 'click'}" #propertiesMenu>
            <kendo-menu-item cssClass="button form-header-button default">
                <ng-template kendoMenuItemLinkTemplate>
                    <span class="flex items-center gap-1.5 text-default">
                        <bizz-icon class="h-4 w-4" iconName="gear"></bizz-icon>
                        <span class="hidden sm:block">{{ 'Properties' | translate }}</span>
                        <bizz-toggle-arrow class="ml-1.5 h-4 w-4"
                                           [direction]="propertiesMenu.direction ? 'up' : 'down'">

                        </bizz-toggle-arrow>
                    </span>
                </ng-template>
                <kendo-menu-item>
                    <ng-template kendoMenuItemTemplate>
                        <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('LinkToRecord' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="link">
                            </bizz-icon>
                            {{ 'LinkToRecord' | translate }}
                        </span>
                    </ng-template>
                    <kendo-menu-item [data]="{ action: MenuAction.CopyLinkToRecord}">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                                <bizz-icon [title]="('CopyLink' | translate)" class="mr-2 size-5 sm:size-4"
                                           [hover]="true" iconName="link">
                                </bizz-icon>
                                {{ 'CopyLink' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                    <kendo-menu-item [data]="{ action: MenuAction.DownloadQrCodeToRecord}">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                                <bizz-icon [title]="('DownloadQR' | translate)" class="mr-2 size-5 sm:size-4"
                                           [hover]="true" iconName="qrcode">
                                </bizz-icon>
                                {{ 'DownloadQR' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                </kendo-menu-item>
                @if (form.CollectionType == CollectionType.ControlledDocument) {
                    <kendo-menu-item>
                        <ng-template kendoMenuItemTemplate>
                        <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('DirectLink' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="files">
                            </bizz-icon>
                            {{ 'DirectLink' | translate }}
                        </span>
                        </ng-template>
                        <kendo-menu-item [data]="{ action: MenuAction.CopyDirectLink}">
                            <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                                <bizz-icon [title]="('CopyLink' | translate)" class="mr-2 size-5 sm:size-4"
                                           [hover]="true" iconName="files">
                                </bizz-icon>
                                {{ 'CopyLink' | translate }}
                            </span>
                            </ng-template>
                        </kendo-menu-item>
                        <kendo-menu-item [data]="{ action: MenuAction.DownloadQRCodeDirectLink}">
                            <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                                <bizz-icon [title]="('DownloadQR' | translate)" class="mr-2 size-5 sm:size-4"
                                           [hover]="true" iconName="qrcode">
                                </bizz-icon>
                                {{ 'DownloadQR' | translate }}
                            </span>
                            </ng-template>
                        </kendo-menu-item>
                    </kendo-menu-item>
                }
                <kendo-menu-item [separator]="true "></kendo-menu-item>
                @if (buttonStates.showPermissionButton) {
                    <kendo-menu-item [data]="{ action: MenuAction.Permissions }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('Permissions' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="lock">
                            </bizz-icon>
                                {{ 'Permissions' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                }
                @if (buttonStates.showPropertiesButton) {
                    <kendo-menu-item [data]="{ action: MenuAction.DocumentSettings }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('DocumentSettings' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="gear">
                            </bizz-icon>
                                {{ 'DocumentSettings' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                    <kendo-menu-item [separator]="true "></kendo-menu-item>
                }
                @if (buttonStates.showFlowStatusButton) {
                    <kendo-menu-item [data]="{ action: MenuAction.FlowStatus }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('FlowStatus' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="chart-line">
                            </bizz-icon>
                                {{ 'FlowStatus' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                }
                @if (buttonStates.showMonitorButton) {
                    <kendo-menu-item [data]="{ action: MenuAction.Monitor }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('Monitor' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="display">
                            </bizz-icon>
                                {{ 'Monitor' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                }
                @if (buttonStates.showHistoryButton) {
                    <kendo-menu-item [data]="{ action: MenuAction.History }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('History' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="clock-rotate-left">
                            </bizz-icon>
                                {{ 'History' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                }
                @if (buttonStates.showTrackChangesButton) {
                    <kendo-menu-item [data]="{ action: MenuAction.TrackChanges }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('TrackChanges' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="clock-rotate-left">
                            </bizz-icon>
                                {{ 'TrackChanges' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                }
                @if (buttonStates.showArchiveButton) {
                    <kendo-menu-item [data]="{ action: MenuAction.Archive }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('Archive' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="box-archive">
                            </bizz-icon>
                                {{ 'Archive' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                }
                @if (buttonStates.showReportButton) {
                    <kendo-menu-item [separator]="true "></kendo-menu-item>
                    <kendo-menu-item [data]="{ action: MenuAction.Report }">
                        <ng-template kendoMenuItemTemplate>
                            <span class="flex items-center gap-1.5 font-semibold">
                            <bizz-icon [title]="('Report' | translate)" class="mr-2 size-5 sm:size-4"
                                       [hover]="true" iconName="file-pdf">
                            </bizz-icon>
                                {{ 'DownloadReport' | translate }}
                            </span>
                        </ng-template>
                    </kendo-menu-item>
                }
            </kendo-menu-item>
        </kendo-menu>
    </div>

    <!-- Properties dropdown -->



    @if ((userType != UserType.AnonymousUser && userType != UserType.ExternalUser) ||
    ((userType == UserType.AnonymousUser || userType == UserType.ExternalUser) && form.TasksID == 0)) {
        <button class="form-header-button default ml-auto" (click)="cancel()">
            @if (readMode) {
                <bizz-icon class="h-4 w-4" iconName="caret-left"></bizz-icon>
            }
            <span>{{ (readMode ? 'Back' : 'Cancel') | translate }}</span>
        </button>
    } @else {
        <!--empty div to keep the default styling applied-->
        <div class="form-header-button default ml-auto h-9">
        </div>
    }

    @if (buttonStates.showEditButton && pwaService.isOnline) {
        <button class="form-header-button default" (click)="editClicked.emit()">
            <bizz-icon class="h-4 w-4" iconName="pen-circle"></bizz-icon>
            {{ 'Edit' | translate }}
        </button>
    }

    @if (buttonStates.showSaveCloseStepButton) {
        <div class="button-group" #saveAnchor>
            <button class="form-header-button save" type="button" (click)="submit(true, true)"
                    [disabled]="formGroup.invalid">
                <bizz-icon class="h-4 w-4" iconName="circle-check"></bizz-icon>
                <span class="leading-none">{{
                    (buttonStates.showExecute
                        ? (userType == UserType.AnonymousUser || userType == UserType.ExternalUser
                            ? 'Submit'
                            : 'Execute')
                        : (userType == UserType.AnonymousUser
                            ? 'Submit'
                            : 'SaveAndCloseStep')) | translate
                    }}</span>
            </button>

            @if (userType != UserType.AnonymousUser) {
                <button class="form-header-button save" type="button" (click)="toggleSavePopup($event)"
                        [disabled]="formGroup.invalid">
                    <bizz-toggle-arrow class="h-4 w-4" [direction]="showSavePopup ? 'up' : 'down'"></bizz-toggle-arrow>
                </button>
            }
        </div>
        @if (showSavePopup) {
            <kendo-popup #savePopup class="z-[1004]" [margin]="{ horizontal: 0, vertical: 5 }"
                         (anchorViewportLeave)="toggleSavePopup($event)" [anchor]="saveAnchor"
                         [anchorAlign]="popupAnchorAlignSave"
                         [popupAlign]="popupAlign"
            >
                <div class="bizz-popup-content text-nowrap bg-green-500 text-white">
                    @if (userType != UserType.AnonymousUser && userType != UserType.ExternalUser) {
                        <button (click)="submit(false, true)" [disabled]="formGroup.invalid">
                            {{ 'SaveAndClose' | translate }}
                        </button>
                    }

                    <button (click)="submit(false, false)" [disabled]="formGroup.invalid">
                        {{ 'Save' | translate }}
                    </button>

                    @if (form.Permissions['CanForwardTasks'] &&
                    (form.byCrossLinkCollectionsID == undefined || form.byCrossLinkCollectionsID <= 0) &&
                    form.TaskInfo != undefined && userType != UserType.AnonymousUser && userType !=
                    UserType.ExternalUser) {
                        <button (click)="forwardTask()" [disabled]="formGroup.invalid">
                            {{ 'ForwardTask' | translate }}
                        </button>
                    }
                </div>
            </kendo-popup>
        }
    }

    @if (buttonStates.showSaveButton) {
        <div class="button-group" #saveAnchor>
            <button class="form-header-button save" type="button" [disabled]="formGroup.invalid"
                    (click)="submit(false, true)">
                <bizz-icon class="h-4 w-4" iconName="circle-check"></bizz-icon>
                <span>{{ 'SaveAndClose' | translate }}</span>
            </button>
            @if (userType != UserType.AnonymousUser && dataItem.options?.parentFormId == undefined) {
                <button class="form-header-button save" type="button" (click)="toggleSavePopup($event)"
                        [disabled]="formGroup.invalid">
                    <bizz-toggle-arrow class="h-4 w-4" [direction]="showSavePopup ? 'up' : 'down'"></bizz-toggle-arrow>
                </button>
            }
        </div>
        @if (showSavePopup) {
            <kendo-popup #savePopup class="z-[1004]" [margin]="{ horizontal: 0, vertical: 5 }"
                         (anchorViewportLeave)="toggleSavePopup($event)" [anchor]="saveAnchor"
                         [anchorAlign]="popupAnchorAlignSave"
                         [popupAlign]="popupAlign"
            >
                <div class="bizz-popup-content bg-green-500 text-white">
                    <button (click)="submit(false, false)" [disabled]="formGroup.invalid">
                        {{ 'Save' | translate }}
                    </button>
                </div>
            </kendo-popup>
        }
    }

</div>